module.exports = __webpack_public_path__ + "img/helpArrow.asset.f4a5a124.svg";